<template>
  <div class="toolbar-container">
    <!-- Left-aligned buttons (Tool buttons grid) -->
    <div class="toolbar-grid pt-4">
      <WebBuilderToolButton 
        :item="radio_item"
        @start-drag="start_drag"
      />
      <WebBuilderToolButton 
        :item="check_item"
        @start-drag="start_drag"
      />
      <WebBuilderToolButton 
        :item="matrix_item"
        @start-drag="start_drag"
      />
      <WebBuilderToolButton 
        :item="dropdown_item"
        @start-drag="start_drag"
      />
      <WebBuilderToolButton 
        :item="slider_item"
        @start-drag="start_drag"
      />
      <WebBuilderToolButton 
        :item="text_item"
        @start-drag="start_drag"
      />
      <WebBuilderToolButton 
        :item="area_item"
        @start-drag="start_drag"
      />
      <WebBuilderToolButton 
        :item="points_item"
        @start-drag="start_drag"
      />
      <WebBuilderToolButton 
        :item="rate_item"
        @start-drag="start_drag"
      />
      <WebBuilderToolButton 
        :item="date_item"
        @start-drag="start_drag"
      />
      <WebBuilderToolButton 
        :item="pagebreak_item"
        @start-drag="start_drag"
      />
      <WebBuilderToolButton 
        :item="upload_item"
        @start-drag="start_drag"
      />
      <WebBuilderToolButton 
        :item="consent_item"
        @start-drag="start_drag"
      />
      <WebBuilderToolButton 
        :item="variable_item"
        @start-drag="start_drag"
      />
    </div>

    <!-- Right-aligned buttons stack vertically -->
    <div class="right-aligned-buttons">
      <button 
        class="toolbar-btn palette-btn" 
        :class="{ selected: selectedButton === 'edit' }"
        @click="selectButton('edit')"
      >
        <span class="svg-icon inline-svg">
          <inline-svg src="/assets/svg/create.svg"></inline-svg>
        </span>
        <span>Innehåll</span>
      </button>

      <button 
        class="toolbar-btn palette-btn" 
        :class="{ selected: selectedButton === 'design' }"
        @click="selectButton('design')"
      >
        <span class="svg-icon inline-svg">
          <inline-svg src="/assets/svg/paint-palette-and-brush.svg"></inline-svg>
        </span>
        <span>Design</span>
      </button>


      <button 
        class="toolbar-btn" 
        :class="{ selected: selectedButton === 'create' }"
        @click="selectButton('create')"
      >
        <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="block-brick" class="btn-image svg-inline--fa fa-block-brick " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M144 80l0 48 56 0 48 0 56 0 0-48L144 80zM96 128l0-48L64 80c-8.8 0-16 7.2-16 16l0 32 48 0zM48 176l0 56 152 0 0-56L48 176zm0 160l48 0 0-56-48 0 0 56zm0 48l0 32c0 8.8 7.2 16 16 16l136 0 0-48-56 0-48 0-48 0zm96-48l160 0 0-56-160 0 0 56zm208 0l48 0 0-56-48 0 0 56zm48 48l-48 0-48 0-56 0 0 48 136 0c8.8 0 16-7.2 16-16l0-32zm0-208l-152 0 0 56 152 0 0-56zm0-48l0-32c0-8.8-7.2-16-16-16l-32 0 0 48 48 0zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96z"></path></svg>
        <span>Block</span>
      </button>

      <button 
        class="toolbar-btn" 
        :class="{ selected: selectedButton === 'settings' }"
        @click="selectButton('settings')"
      >
        <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="table-columns" class="btn-image svg-inline--fa fa-table-columns " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M48 416l0-256 184 0 0 272L64 432c-8.8 0-16-7.2-16-16zm232 16l0-272 184 0 0 256c0 8.8-7.2 16-16 16l-168 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z"></path></svg>
        <span>Sida</span>
      </button>

      <button 
        class="toolbar-btn" 
        :class="{ selected: selectedButton === 'global' }"
        @click="selectButton('settings')"
      >
        <img class="toolbar-btn-icon" src="/assets/svg/global.svg" alt="Global" />
        <span>Globalt</span>
      </button>
    </div>
  </div>
</template>



<script>
import WebBuilderToolButton from '@/view/components/web_builder/WebBuilderToolButton.vue';

export default {
  name: 'WebBuilderToolbar',
  components: {
    WebBuilderToolButton,
  },
  emits: ['start-drag'],
  data() {
    return {
      selectedButton: 'edit',
      radio_item: {
        name: this.$t('SURVEY.RADIO_LIST'), type: 'WebBuilderSurveyRadio', svg: '/assets/svg/radio-list.svg',
        header: 'Beskriv frågan',
        options: [ { text: '<p>Beskriv svar 1</p>', value: 1 }, { text: '<p>Beskriv svar 2</p>', value: 2 }, ]
      },
      check_item: {
        name: this.$t('SURVEY.CHECK_LIST'), type: 'WebBuilderSurveyCheckbox', svg: '/assets/svg/checkbox.svg',
        header: 'Beskriv frågan',
        options: [ { text: '<p>Beskriv svar 1</p>', value: 1 }, { text: '<p>Beskriv svar 2</p>', value: 2 }, ]
      },
      rate_item: {
        name: this.$t('SURVEY.RATE'), type: 'WebBuilderSurveyRate', svg: '/assets/svg/rate.svg'
      },
      points_item: {
        name: this.$t('SURVEY.POINTS'), type: 'WebBuilderSurveyPoints', svg: '/assets/svg/points2.svg'
      },
      upload_item: {
        name: this.$t('SURVEY.FILE_UPLOAD'), type: 'WebBuilderSurveyFileUpload', svg: '/assets/svg/file-upload.svg'
      },
      slider_item: {
        name: this.$t('SURVEY.SLIDER'), header: 'Beskriv frågan', min_value: 1, max_value: 100, steps: 1, type: 'WebBuilderSurveySlider', svg: '/assets/svg/slider.svg'
      },
      dropdown_item: {
        name: this.$t('SURVEY.DROPDOWN'), type: 'WebBuilderSurveyDropdown', svg: '/assets/svg/dropdown.svg'
      },
      variable_item: {
        name: this.$t('SURVEY.VARIABLE'), type: 'WebBuilderSurveyVariable', svg: '/assets/svg/eye-hidden.svg'
      },
      consent_item: {
        name: this.$t('SURVEY.CONSENT'), type: 'WebBuilderSurveyConsent', svg: '/assets/svg/consent.svg'
      },
      pagebreak_item: {
        name: this.$t('SURVEY.PAGEBREAK'), type: 'WebBuilderSurveyPageBreak', svg: '/assets/svg/page-break.svg'
      },
      text_item: {
        name: this.$t('SURVEY.TEXT_INPUT'), type: 'WebBuilderSurveyText', svg: '/assets/svg/text-single-row2.svg'
      },
      area_item: {
        name: this.$t('SURVEY.AREA_INPUT'), type: 'WebBuilderSurveyTextarea', svg: '/assets/svg/text-multirow2.svg'
      },
      matrix_item: {
        name: this.$t('SURVEY.MATRIX'), type: 'WebBuilderSurveyMatrix', svg: '/assets/svg/matrix.svg'
      },
      date_item: {
        name: this.$t('SURVEY.DATE'), type: 'WebBuilderSurveyDate', svg: '/assets/svg/calendar-31.svg'
      },
      
      items: [
        { name: 'Row', type: 'WebBuilderLayoutRow' },
        { name: 'Text Block', type: 'WebBuilderSimpleComponent' }
      ]
    };
  },
  methods: {
    selectButton(button) {
      this.selectedButton = button; // Set the selected button
    },
    onMouseDown(item, event, index) {
      console.log('onMouseDown tool');
      this.$emit('start-drag', item.type, { x: event.clientX, y: event.clientY });
      event.dataTransfer.setData('componentType', item.type); 
      event.dataTransfer.setDragImage(event.target, 0, 0); 
    },
    start_drag(item, event) {
      console.log('child tool button drag start', item, event);
      this.$emit('start-drag', item, { x: event.clientX, y: event.clientY });
    },
    onDragStart(item, event, index) {
      this.$emit('start-drag', item.type, { x: event.clientX, y: event.clientY });
      event.dataTransfer.setData('componentType', item.type); 
      event.dataTransfer.setDragImage(event.target, 0, 0);
    },
    editSelected() {
      console.log('Edit selected item');
    },
    openSettings() {
      console.log('Open global settings');
    }
  },
  computed: {
    itemStyle() {
      return {
        width: '120px',
        height: '120px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '8px',
        border: '1px solid #ddd',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        margin: '10px',
      };
    }
  }
};
</script>

<style scoped>

.btn-image {
  height: 2em;
}
/* Main container holding toolbar grid and right-aligned buttons */
.toolbar-container {
  height: 100%;
  display: flex;
  justify-content: space-between;
}

.toolbar-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 12px;
  background-color: #f9f9f9;
  padding-left: 8px;
  align-content: flex-start;
}

.right-aligned-buttons {
  border-left: 1px solid #dedede;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: #d4d4d4;
}

.toolbar-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  background-color: #d4d4d4;
  color: rgb(59, 59, 59);
  border: none;
  cursor: pointer;
  width: 100%;
  gap: 8px;
  text-transform: capitalize;
  transition: background-color 0.3s ease;
  width: 96px;
  height: 96px;
}

.toolbar-btn:hover {
  background-color: #e0e0e0;
}

.toolbar-btn.selected {
  background-color: #f9f9f9;
  color: rgb(59, 59, 59);
}

.toolbar-btn.selected:hover {
  background-color: #606468;
}

.toolbar-btn-icon {
  width: 36px;
  height: 36px;
}
.palette-btn .svg-icon svg {
  width: 36px !important;  /* Adjust width */
  height: 36px !important; /* Adjust height */
}
.palette-btn .svg-icon svg path {
  stroke-width: 6 !important;  /* Thicker lines */
  stroke: black; /* Set stroke color */
  fill: currentColor; /* Ensure the fill is the same as the color */
}
</style>

